<template>
  <page-layout>
    <div class="demand-list">
      <div class="head">
        <div class="title">
          <a-row>
            <a-col :xs="24">
              <h3>全部需求</h3>
            </a-col>
            <a-col :xs="24"></a-col>
          </a-row>

          <div>
            <div style="display: inline-block">
              排序方式
              <a-select
                v-model="order"
                style="width: 130px;margin-left: 4px;"
                placeholder="不限"
                @change="filterChange"
              >
                <a-select-option value="verified_at">按更新时间</a-select-option>
                <a-select-option value="favorited_count">按收藏数</a-select-option>
                <a-select-option value="related_project_count">按相关项目数</a-select-option>
                <a-select-option value="viewed_count">按热度值</a-select-option>
                <a-select-option value="created_at">按发布时间</a-select-option>
                <a-select-option value="expired_at">按截止时间</a-select-option>
              </a-select>
            </div>
            <div style="display: inline-block;margin-left: 20px">
              <a-input-search
                style="width: 350px"
                placeholder="请输入关键词搜索"
                v-model="keyword"
                @search="filterChange"
                enterButton="搜索"
              />
            </div>
          </div>
        </div>
        <div class="filters">
          <a-row :gutter="24" type="flex">
            <!-- 技术领域 -->
            <a-col :xs="24" :xl="12" :xxl="12">
              <span class="label">技术领域</span>
              <div class="filter">
                <a-select
                  @change="filterChange"
                  v-model="filters.areas"
                  allowClear
                  mode="multiple"
                  placeholder="不限"
                  style="width: 100%;"
                >
                  <a-select-option v-for="item in areas" :key="item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </div>
            </a-col>
            <!-- 需求来源地 -->
            <a-col :xs="24" :xl="12" :xxl="12">
              <span class="label">需求来源地</span>
              <div class="filter">
                <a-cascader
                  @change="filterChange"
                  changeOnSelect
                  v-model="filters.location"
                  :options="areaOptions"
                  placeholder="不限"
                  style="width: 100%;"
                ></a-cascader>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="main">
        <a-list
          itemLayout="vertical"
          size="large"
          :loading="loading"
          :grid="{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 3, xl: 3, xxl: 4 }"
          :dataSource="demands"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <demand-item :data="item" :key="item.id"></demand-item>
          </a-list-item>
        </a-list>
      </div>

      <div class="foot">
        <a-pagination
          :current="pagination.pageNo"
          :pageSize="pagination.pageSize"
          :total="pagination.count"
          @change="pageChange"
        />
      </div>
    </div>
  </page-layout>
</template>

<script>
import { Demands } from '@/resources'
import { areaOptions } from '@/utils/constants/area'
import { techAreas } from '@/utils/constants/options'
import _ from 'lodash'
import PageLayout from '@/components/page/PageLayout'
import CountDown from '@/components/CountDown'
import DemandItem from '@/components/DemandItem'

export default {
  components: {
    PageLayout,
    CountDown,
    DemandItem
  },
  data () {
    return {
      keyword: null,
      loading: false,
      pagination: {
        pageNo: 1,
        pageSize: 12,
        count: 0
      },
      areas: techAreas,
      areaOptions,
      demands: [],
      filters: {
        areas: [],
        applicationIndustries: [],
        hasPatent: undefined,
        cooperationWay: [],
        location: [],
        demandType: undefined
      },
      order: 'verified_at'
    }
  },
  computed: {
  },
  created () {
    const vm = this
    vm.fetchData()
  },
  methods: {
    pageChange (current) {
      const vm = this
      vm.pagination.pageNo = current
      vm.fetchData()
    },
    filterChange () {
      const vm = this
      vm.pagination.pageNo = 1
      vm.fetchData()
    },
    async fetchData () {
      this.loading = true
      const params = _.cloneDeep(this.filters)
      if (this.keyword) params.text = this.keyword
      if (typeof params.hasPatent === 'string') {
        params.hasPatent = params.hasPatent === '有'
      } else {
        Reflect.deleteProperty(params, 'hasPatent')
      }
      ;['areas', 'applicationIndustries', 'cooperationWay', 'location'].forEach(key => {
        if (params[key].length < 1) {
          Reflect.deleteProperty(params, key)
        } else {
          if (Array.isArray(params[key])) {
            params[key] = params[key].join(',')
          }
        }
      })
      const req = Object.assign({ order: this.order }, params, this.pagination)
      const { demands, count } = await Demands.list(req)
      this.demands = demands
      this.pagination.count = count
      this.loading = false
    }
  }
}
</script>

<style scoped lang="less">
.head {
  background-color: #fff;
  border-radius: 2px;
  padding: 20px 20px 0px 20px;
  margin-bottom: 16px;
  .title {
    height: 46px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    h3 {
      font-weight: 700;
      color: #666;
    }
  }
  .filters {
    padding: 20px 0;
    margin-bottom: 8px;
    .label {
      display: inline-block;
      text-align: left;
      margin-bottom: 4px;
    }
    .filter {
      display: inline-block;
      width: 100%;
    }
  }
}

.main {
  background: inherit;
}

.foot {
  margin: 15px 0;
  text-align: right;
}
</style>
